import { RadioGroup as o } from "@headlessui/vue";
import { defineComponent as r, toRef as t } from "vue";
import { provideThemeColor as i } from "../../composables/theme.mjs";
const m = {
  gray: "bg-zinc-100 dark:bg-zinc-850",
  white: "bg-zinc-100 dark:bg-zinc-850",
  primary: "bg-primary-600"
}, u = r({
  name: "TuiSwitchButtonGroup",
  components: {
    RadioGroup: o
  },
  props: {
    modelValue: {
      type: [String, Boolean, Number, Object],
      required: !0
    },
    color: {
      type: String,
      default: "gray"
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    i(t(() => e.color));
  },
  computed: {
    classes() {
      return m[this.color];
    },
    modelProxy: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
});
export {
  u as default
};
//# sourceMappingURL=SwitchButtonGroup.vue2.mjs.map
